module.exports = __webpack_public_path__ + "img/pulse.e00819b9.png";